/*------------------------------------*\
    EVENT CARD
\*------------------------------------*/
class EventCard {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.body = self.elem.querySelector('[data-event-card-body]');
        self.toggle = self.elem.querySelector('[data-event-card-toggle]');
        self.isOpen = false;
    }

    init() {
        let self = this;

        self.showOrHideToggle();

        window.addEventListener('resize', evt => {
            self.showOrHideToggle();
        });

        self.toggle.addEventListener('click', evt => {
            if (self.isOpen) {
                // Close it
                self.close();
            } else {
                // Open it
                self.open();
            }
        });
    }

    open() {
        let self = this;

        self.elem.classList.add('is-open');
        self.toggle.setAttribute('aria-expanded', true);

        self.isOpen = true;
    }

    close() {
        let self = this;

        self.elem.classList.remove('is-open');
        self.toggle.setAttribute('aria-expanded', false);

        self.isOpen = false;
    }

    showOrHideToggle() {
        let self = this;

        // If the text is 3 lines of less tall, remove the toggle button
        if(self.body.scrollHeight <= self.body.clientHeight) {
            self.toggle.classList.add('d-none');
        } else {
            self.toggle.classList.remove('d-none');
        }
    }
}

export default EventCard;
